import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { routes } from './management.routes';

import { AttributeUpdatedInfoComponent } from '@emm/shared/components/attribute-updated-info/attribute-updated-info.component';

@NgModule({
    imports: [RouterModule.forChild(routes), CommonModule],
    declarations: [
        AttributeUpdatedInfoComponent
    ],
    exports: [RouterModule, AttributeUpdatedInfoComponent]
})
export class ManagementRoutingModule {}
